import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxGlobalLaw.css';

const RedboxGlobalLaw = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Global Law - Legal Services & Compliance Solutions | Redbox Global</title>
        <meta name="description" content="Redbox Global Law provides comprehensive legal services, regulatory compliance solutions, corporate governance expertise, and financial law advisory for global financial institutions and enterprises." />
        <meta name="keywords" content="legal services, financial law, regulatory compliance, corporate governance, legal advisory, financial regulations, securities law, compliance solutions, legal consulting, Redbox Global Law, financial services law" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/law" />
        <meta property="og:title" content="Redbox Global Law - Legal Services & Compliance | Redbox Global" />
        <meta property="og:description" content="Expert legal services and regulatory compliance solutions for the financial services industry worldwide." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/law" />
        <meta name="twitter:title" content="Redbox Global Law - Legal Services & Compliance" />
        <meta name="twitter:description" content="Comprehensive legal services and compliance solutions for financial institutions." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/law" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "Redbox Global Law",
            "description": "Legal services and regulatory compliance solutions for financial services industry.",
            "url": "https://redboxglobal.com/law",
            "provider": {
              "@type": "Organization",
              "name": "Redbox Global",
              "logo": {
                "@type": "ImageObject",
                "url": "https://redboxglobal.com/logo.png"
              }
            },
            "serviceType": "Legal Services and Regulatory Compliance",
            "areaServed": "Worldwide",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Legal Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Regulatory Compliance Advisory"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Corporate Governance Solutions"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Securities & Financial Law"
                  }
                }
              ]
            }
          })}
        </script>
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Law</h1>
          <p className="page-subtitle">
            Legal analysis, regulatory developments, and global governance insights
          </p>
        </div>

        <div className="page-content">

          {/* Featured Article */}
          <a 
            href="/article/global-regulatory-trends-2026" 
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img 
                  src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&h=600&fit=crop" 
                  alt="Courtroom and legal documents" 
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Featured Analysis</span> */}
                <h2>Global Regulatory Shifts Reshaping Corporate Governance in 2026</h2>
                <p>
                  A comprehensive review of emerging international regulatory frameworks 
                  impacting multinational corporations and cross-border compliance.
                </p>
                <span className="article-meta">February 10, 2026</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">

            <a 
              href="/article/international-trade-law-reform" 
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img 
                    src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop" 
                    alt="International trade documents" 
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Trade Law</span> */}
                  <h2>International Trade Law Reform: What Businesses Must Know</h2>
                  <p>
                    Key updates in global trade agreements and their implications 
                    for multinational enterprises.
                  </p>
                  <span className="article-meta">February 7, 2026</span>
                </div>
              </article>
            </a>

            <a 
              href="/article/data-privacy-regulations-2026" 
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img 
                    src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop" 
                    alt="Data privacy concept" 
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Compliance</span> */}
                  <h2>Data Privacy Regulations Tighten Across Major Economies</h2>
                  <p>
                    An overview of new compliance standards and enforcement trends 
                    affecting global digital enterprises.
                  </p>
                  <span className="article-meta">February 5, 2026</span>
                </div>
              </article>
            </a>

            <a 
              href="/article/corporate-litigation-trends" 
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img 
                    src="https://images.unsplash.com/photo-1505664194779-8beaceb93744?w=600&h=400&fit=crop" 
                    alt="Legal courtroom discussion" 
                  />
                </div>
                <div className="article-content"> 
                  {/* <span className="article-category">Litigation</span> */}
                  <h2>Corporate Litigation Trends to Watch in 2026</h2>
                  <p>
                    Emerging dispute patterns and risk mitigation strategies for 
                    global enterprises.
                  </p>
                  <span className="article-meta">February 2, 2026</span>
                </div>
              </article>
            </a>

          </div>

        </div>
      </div>
    </>
  );
};

export default RedboxGlobalLaw;
